/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * ProvenanceBadge.tsx — Provenanc\1 \2adge (services/operator-web-app).
 */

import type { FieldSource } from '@/store';
import { Badge } from '@/components/ui';
import { useTranslation } from '@/i18n';

const SOURCE_VARIANTS: Record<FieldSource, 'neutral' | 'info' | 'success'> = {
  manual: 'neutral',
  ai_apply: 'info',
  integration: 'success',
};

export function ProvenanceBadge({ source }: { source: FieldSource }) {
  const t = useTranslation();
  return (
    <Badge variant={SOURCE_VARIANTS[source]} className="text-[10px] px-1.5 py-0">
      {t(`provenance.${source}`)}
    </Badge>
  );
}
